import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { path } from 'ramda'
import Review from 'Components/Review'
// import styles from './SingleStyles'

class VideosSingle extends Component {
  constructor (props) {
    super(props)

    this.documentTitle = ''
    this.state = {
      videoId: Number(path(['params', 'videoId'], this.props.match))
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.match !== nextProps.match) {
      this.setState({
        videoId: Number(path(['params', 'videoId'], nextProps.match))
      })
    }
  }

  render () {
    if (!this.state.videoId) return null
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{this.documentTitle} - Video Review</title>
        </Helmet>
        <Review
          videoId={this.state.videoId}
          history={this.props.history} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(VideosSingle)



// WEBPACK FOOTER //
// ./src/Pages/Videos/Single.js